<main>
  <app-new-sidebar class="destop-view"></app-new-sidebar>

  <div class="h-screen w-screen flex flex-col">
    <div class="container">
      <div
        id="toolbar-container "
        style="max-width: 835px"
        class="flex items-center flex-col"
      >
        <editor-toolbar-top></editor-toolbar-top>
        <app-tabview-sidebar class="tab-view"></app-tabview-sidebar>
      </div>
    </div>
    <div
      class="container flex-1 grid p-base pb-1 gap-lg overflow-hidden"
      [ngClass]="{ 'grid-cols-2': editorState.response }"
    >
      <div class="h-full flex flex-col overflow-hidden">
        <div
          class="h-full flex flex-col border-sections rounded-lg overflow-hidden"
        >
          <div class="flex items-center justify-between p-symmetric pt-2 pl-1">
            <div class="border-none" #editorToolbar>
              <span class="has-tooltip">
                <button class="ql-bold"></button>
                <span class="tooltip-content tooltip-bottom">Bold</span>
              </span>
              <span class="has-tooltip">
                <button class="ql-italic"></button>
                <span class="tooltip-content tooltip-bottom">Italic</span>
              </span>
              <span class="has-tooltip">
                <button class="ql-underline"></button>
                <span class="tooltip-content tooltip-bottom">Underline</span>
              </span>
              <span class="has-tooltip">
                <button class="ql-align" value=""></button>
                <span class="tooltip-content tooltip-bottom">Align Left</span>
              </span>
              <span class="has-tooltip">
                <button class="ql-align" value="center"></button>
                <span class="tooltip-content tooltip-bottom">Align Center</span>
              </span>
              <span class="has-tooltip">
                <button class="ql-align" value="right"></button>
                <span class="tooltip-content tooltip-bottom">Align Right</span>
              </span>
              <span class="has-tooltip">
                <button class="ql-list" value="bullet"></button>
                <span class="tooltip-content tooltip-bottom"
                  >Unordered List</span
                >
              </span>
              <span class="has-tooltip">
                <button class="ql-list" value="ordered"></button>
                <span class="tooltip-content tooltip-bottom">Ordered List</span>
              </span>
              <span class="has-tooltip">
                <button class="ql-blockquote"></button>
                <span class="tooltip-content tooltip-bottom">Blockquote</span>
              </span>
            </div>

            <!-- <div
            style="position: relative"
            class="grid items-center switch-language-dropdown-container"
          >
            <button
              (click)="toggleReportMenu($event)"
              class="switch-language-dropdown flex items-center gap-default justify-between"
            >
              <span class="flex gap-default items-center text-sm">
                <app-icons-free-tools
                  *ngIf="!iconRequireReattachment"
                  [name]="languages[selectedLanguage].icon"
                ></app-icons-free-tools>
                {{ languages[selectedLanguage].name }}
              </span>
              <app-icons name="chevronDown"></app-icons>
            </button>

            <ul
              style="display: none"
              class="language-menu p-0"
              (click)="switchLanguage($event)"
            >
              <li
                [attr.data-language]="language"
                *ngFor="let language of Object.keys(languages)"
              >
                <app-icons-free-tools
                  [name]="languages[language].icon"
                ></app-icons-free-tools>
                {{ languages[language].name }}
              </li>
            </ul>
          </div> -->
          </div>

          <div
            class="p-symmetric pt-0 flex-1 text-lg overflow-y-auto scrollable h-full"
            [ngClass]="{ relative: !editorEnabled }"
          >
            <div #editor spellcheck="false"></div>

            <section
              class="container absolute inset-0 p-symmetric pt-2"
              [ngClass]="{ 'd-none': !(!editorEnabled && !editorState.words) }"
              (click)="renderEditor()"
              style="cursor: text"
            >
              <h4 class="mb-3" style="font-size: 20px">
                Type or paste (Ctrl+V) your text here.
              </h4>
              <p style="font-size: 16px">Or, upload a document.</p>
              <app-upload-file></app-upload-file>
            </section>
          </div>

          <div
            class="grid"
            [ngClass]="{ 'grid-cols-2': !editorState.response }"
            style="min-height: 69px"
          >
            <div class="p-symmetric flex gap-default">
              <!-- @for (m of modes; track m) {
              <button
                class="flex-1 mode-toggles text-sm"
                style="text-transform: capitalize"
                [ngClass]="{ active: m === editorState.mode }"
                (click)="editorState.mode = m"
              >
                {{ m }}
              </button>
              } -->
            </div>
          </div>
        </div>

        <div
          class="flex justify-between items-center p-base px-0"
          style="min-height: 78px"
        >
          <ul
            class="flex gap-default items-center list-style-none m-0 p-0 text-sm"
          >
            <li>Words: {{ f(editorState.words) }}</li>
            <li>|</li>
            <li>Characters: {{ f(editorState.characters) }}</li>
          </ul>

          <button
            *ngIf="!editorState.response"
            class="check-grammar-btn"
            [ngClass]="{
              'check-grammar-btn-loading': editorState.state === 'loading'
            }"
            [disabled]="editorState.state === 'loading'"
            (click)="editorState.words < 15 ? invokeModal($event) : rewrite()"
            [attr.data-target]="'empty-content-modal'"
          >
            {{
              editorState.state === "loading" ? "Rewriting" : "Rewrite Article"
            }}
          </button>
        </div>
      </div>
      <div
        class="h-full overflow-hidden flex flex-col"
        *ngIf="editorState.response"
      >
        <div
          class="h-full flex flex-col border-sections rounded-lg overflow-hidden"
        >
          <!-- Results Container -->
          <div class="flex items-center" style="min-height: 64px">
            <h3 class="fs-4 fw-medium m-0" style="padding-inline-start: 1.5rem">
              Result
            </h3>
          </div>

          <div
            class="h-full flex-1 overflow-y-auto scrollable p-base py-0 relative"
            style="line-height: 2.5rem"
            *ngIf="editorState.response"
          >
            <p
              class="mb-0"
              id="HTPD2M2708"
              (click)="onResultsClick($event)"
            ></p>

            <div
              *ngIf="popup.content.length"
              class="absolute popup rounded-lg p-3 pt-1"
              [style.top.px]="popup.y"
              [style.left.px]="popup.x"
            >
              <section>
                <div class="flex justify-between items-center">
                  <h3 class="fs-6 mb-0">Original Word</h3>

                  <button class="fs-6" (click)="dismissPopup()">
                    <svg
                      width="22"
                      height="23"
                      viewBox="0 0 22 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 11.5996C1 12.9128 1.25866 14.2132 1.7612 15.4264C2.26375 16.6397 3.00035 17.7421 3.92893 18.6707C4.85752 19.5993 5.95991 20.3359 7.17317 20.8384C8.38642 21.341 9.68678 21.5996 11 21.5996C12.3132 21.5996 13.6136 21.341 14.8268 20.8384C16.0401 20.3359 17.1425 19.5993 18.0711 18.6707C18.9997 17.7421 19.7363 16.6397 20.2388 15.4264C20.7413 14.2132 21 12.9128 21 11.5996C21 10.2864 20.7413 8.98603 20.2388 7.77278C19.7363 6.55952 18.9997 5.45713 18.0711 4.52854C17.1425 3.59996 16.0401 2.86336 14.8268 2.36081C13.6136 1.85827 12.3132 1.59961 11 1.59961C9.68678 1.59961 8.38642 1.85827 7.17317 2.36081C5.95991 2.86336 4.85752 3.59996 3.92893 4.52854C3.00035 5.45713 2.26375 6.55952 1.7612 7.77278C1.25866 8.98603 1 10.2864 1 11.5996Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.14307 8.74219L13.8569 14.456M13.8569 8.74219L8.14307 14.456"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>

                <div>
                  <button
                    class="fs-6 popup-btn-primary"
                    [attr.data-replacement]="popup.content[0]"
                    (click)="handlePopupClick($event)"
                  >
                    {{ popup.content[0] }}
                  </button>
                </div>
              </section>

              <section class="mt-3">
                <h4 class="fs-6">Suggestions</h4>

                <div class="flex flex-wrap gap-sm">
                  <button
                    *ngFor="let word of popup.content"
                    [attr.data-replacement]="word"
                    class="fs-6 btn-secondary py-0 px-3 rounded-lg"
                    (click)="handlePopupClick($event)"
                  >
                    {{ word }}
                  </button>
                </div>
              </section>

              <section class="mt-3">
                <h4 class="fs-6">Enter New</h4>

                <div class="flex gap-default">
                  <input
                    type="text"
                    class="fs-6 popup-input flex-1 rounded-lg px-2"
                    [placeholder]="'e.g. ' + popup.content[0]"
                    id="popup-replacement-input"
                  />

                  <button
                    class="fs-6 popup-btn-dark"
                    (click)="handlePopupClick($event)"
                  >
                    Use
                  </button>
                </div>
              </section>
            </div>
          </div>

          <section
            class="h-full grid place-items-center flex-1"
            *ngIf="!editorState.response"
          >
            <app-empty-content></app-empty-content>
          </section>
          <div style="min-height: 69px" class="md-hidden"></div>
        </div>

        <div
          class="flex justify-between items-center p-base px-0"
          style="min-height: 78px"
          *ngIf="editorState.response"
        >
          <ul
            class="flex gap-default items-center list-style-none m-0 p-0 text-sm"
          >
            <!-- show count for the right hand section -->
            <li>Words: {{ f(editorState.res_words) }}</li>
            <li>|</li>
            <li>Characters: {{ f(editorState.res_characters) }}</li>
          </ul>

          <ul class="flex gap-default items-center list-style-none m-0 p-0">
            <li>
              <button
                class="btn-outline has-tooltip"
                (click)="copyToClipboard()"
              >
                <app-icons name="copyIcon" />

                <span class="tooltip-content tooltip-top">Copy</span>
              </button>
            </li>
            <li>
              <button class="btn-outline has-tooltip" (click)="clearEditor()">
                <app-icons name="clearIcon" />

                <span class="tooltip-content tooltip-top">Clear</span>
              </button>
            </li>
            <li>
              <button
                class="btn-outline has-tooltip"
                (click)="downloadReport()"
              >
                <app-icons-free-tools name="downloadTabIcon" />

                <span class="tooltip-content tooltip-top">Download</span>
              </button>
            </li>
            <li>
              <button
                class="check-grammar-btn"
                [ngClass]="{
                  'check-grammar-btn-loading': editorState.state === 'loading'
                }"
                [disabled]="editorState.state === 'loading'"
                (click)="
                  editorState.words < 15 ? invokeModal($event) : rewrite()
                "
                [attr.data-target]="'empty-content-modal'"
              >
                {{
                  editorState.state === "loading"
                    ? "Rewriting"
                    : "Rewrite Article"
                }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <app-modal parent="content-exceeds-words-limit-modal">
    <modal-content>
      <section class="text-center grid justify-center">
        <h3>Content Exceeds Words Limit</h3>

        <p>
          Please reduce your content to less than
          {{ f(authLimits[authState].words) }} words.
        </p>

        <div>
          <button
            class="check-grammar-btn w-unset"
            (click)="dismissModal($event)"
            style="max-width: unset !important"
          >
            Dismiss
          </button>
        </div>
      </section>
    </modal-content>
  </app-modal>

  <app-modal parent="empty-content-modal">
    <modal-content>
      <section class="text-center grid justify-center">
        <h3>Enter at least 15 words.</h3>

        <p>Please enter at least 15 words to proceed.</p>

        <div>
          <button
            class="check-grammar-btn w-unset"
            (click)="dismissModal($event)"
            style="max-width: unset !important"
          >
            Dismiss
          </button>
        </div>
      </section>
    </modal-content>
  </app-modal>
</main>
